import { render, staticRenderFns } from "./DialogueDynamic.vue?vue&type=template&id=35ef7239&scoped=true&"
import script from "./DialogueDynamic.vue?vue&type=script&lang=js&"
export * from "./DialogueDynamic.vue?vue&type=script&lang=js&"
import style0 from "./DialogueDynamic.vue?vue&type=style&index=0&id=35ef7239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef7239",
  null
  
)

export default component.exports